import api from "../../api";
import {
    PRODUCT_CREATE_REQUEST,
    PRODUCT_CREATE_SUCCESS,
    PRODUCT_CREATE_FAIL,

    PRODUCT_IMPORT_REQUEST,
    PRODUCT_IMPORT_PROGRESS,
    PRODUCT_IMPORT_SUCCESS,
    PRODUCT_IMPORT_FAIL,

    ALL_PRODUCTS_REQUEST,
    ALL_PRODUCTS_SUCCESS,
    ALL_PRODUCTS_FAIL,


    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAIL,


    DELETE_PRODUCT_REQUEST,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAIL,

    SINGLE_PRODUCT_REQUEST,
    SINGLE_PRODUCT_SUCCESS,
    SINGLE_PRODUCT_FAIL,

    CLEAR_ERRORS
} from "../constants/productConstants";

export const createProductAction = (productData) => async (dispatch) => {
    try {
        dispatch({ type: PRODUCT_CREATE_REQUEST });

        const { data } = await api.post(
            "/api/v1/product/create",
            productData,
            { headers: { "Content-Type": "application/json" } }
        );

        dispatch({
            type: PRODUCT_CREATE_SUCCESS,
            payload: data.message
        });

    } catch (error) {
        dispatch({
            type: PRODUCT_CREATE_FAIL,
            payload: error.response?.data?.message || error.message
        });
    }
};

export const importProductsBulkAction = (products, setProgress) => async (dispatch) => {
    try {
        dispatch({ type: PRODUCT_IMPORT_REQUEST });

        const CHUNK_SIZE = 200;
        let imported = 0;
        let backendImportCount = 0;
        let backendSkipCount = 0;

        for (let i = 0; i < products.length; i += CHUNK_SIZE) {
            const chunk = products.slice(i, i + CHUNK_SIZE);

            const { data } = await api.post("/api/v1/product/import/bulk", { products: chunk });

            backendImportCount += data.inserted;
            backendSkipCount += data.skipped;

            imported += chunk.length;

            const percent = Math.round((imported / products.length) * 100);

            dispatch({
                type: PRODUCT_IMPORT_PROGRESS,
                payload: {
                    percent,
                    inserted: backendImportCount,
                    skipped: backendSkipCount
                }
            });

            if (setProgress) setProgress(percent);
        }


        dispatch({
            type: PRODUCT_IMPORT_SUCCESS,
            payload: {
                message: "Products imported successfully",
                inserted: backendImportCount,
                skipped: backendSkipCount
            }
        });

    } catch (error) {
        dispatch({
            type: PRODUCT_IMPORT_FAIL,
            payload: error.response?.data?.message || error.message
        });
    }
};




export const allProductsAction = (page = 1, queryParams = {}) => async (dispatch) => {
    try {
        dispatch({ type: ALL_PRODUCTS_REQUEST });

        const { data } = await api.get(
            `/api/v1/all-products?page=${page}&${new URLSearchParams(queryParams).toString()}`
        );

        console.log(data)

        dispatch({

            type: ALL_PRODUCTS_SUCCESS,
            payload: data

        });

    } catch (error) {
        dispatch({
            type: ALL_PRODUCTS_FAIL,
            payload: error.response?.data?.message || error.message
        });
    }
};
export const singleProductAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: SINGLE_PRODUCT_REQUEST });

        const { data } = await api.get(
            `/api/v1/single-product?id=${id}`
        );


        console.log(data)

        dispatch({

            type: SINGLE_PRODUCT_SUCCESS,
            payload: data

        });

    } catch (error) {
        dispatch({
            type: SINGLE_PRODUCT_FAIL,
            payload: error.response?.data?.message || error.message
        });
    }
};



export const updateProductAction = (id, productData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_PRODUCT_REQUEST });

        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const { data } = await api.put(`/api/v1/product/update?id=${id}`, productData, config);

        dispatch({
            type: UPDATE_PRODUCT_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_PRODUCT_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};

// -------------------
// DELETE PRODUCT
// -------------------
export const deleteProductAction = (id) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_PRODUCT_REQUEST });

        const { data } = await api.delete(`/api/v1/product/delete?id=${id}`);

        dispatch({
            type: DELETE_PRODUCT_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: DELETE_PRODUCT_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};




export const clearErrors = () => (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
};
